module.exports = __webpack_public_path__ + "static/media/3.22_preview.5d14e49c.png";